import { isDistributorRole } from "lib/portalRoles";

export function isPortalNavActive(pathname, route) {
  if (!route) return false;
  const path = String(pathname || "").replace(/\/+$/, "") || "/";
  const r = String(route).replace(/\/+$/, "");
  if (r === "/account") return path === "/account";
  if (r.startsWith("/account/")) return path === r || path.startsWith(`${r}/`);
  return path === r || path.startsWith(`${r}/`);
}

/** Left-rail navigation grouped for the portal shell. */
export function portalSidebarSections(t, distributor) {
  const account = distributor
    ? [
        {
          label: t("portal.overview", "Overview"),
          route: "/account",
          icon: "dashboard",
        },
        {
          label: t("portal.distributorRequests", "Order requests"),
          route: "/account/distributor-requests",
          icon: "rule",
        },
        {
          label: t("portal.linkedCustomers", "Linked customers"),
          route: "/account/distributor-customers",
          icon: "groups",
        },
        {
          label: t("portal.orders", "Orders"),
          route: "/account/orders",
          icon: "receipt_long",
        },
        {
          label: t("portal.registeredUnits", "Registered Items"),
          route: "/account/valve-bodies",
          icon: "qr_code_2",
        },
        {
          label: t("portal.profile", "Profile"),
          route: "/account/profile",
          icon: "person",
        },
        {
          label: t("portal.addresses", "Addresses"),
          route: "/account/addresses",
          icon: "location_on",
        },
      ]
    : [
        {
          label: t("portal.overview", "Overview"),
          route: "/account",
          icon: "dashboard",
        },
        {
          label: t("portal.registeredUnits", "Registered Items"),
          route: "/account/valve-bodies",
          icon: "qr_code_2",
        },
        {
          label: t("portal.coreReturns", "Core returns"),
          route: "/account/core-returns",
          icon: "replay",
        },
        {
          label: t("portal.orders", "Orders"),
          route: "/account/orders",
          icon: "receipt_long",
        },
        {
          label: t("portal.profileBilling", "Profile / Billing"),
          route: "/account/profile",
          icon: "person",
        },
        {
          label: t("portal.addresses", "Addresses"),
          route: "/account/addresses",
          icon: "location_on",
        },
      ];

  const store = [
    {
      label: t("common.catalog", "Catalog"),
      route: "/catalog",
      icon: "storefront",
    },
    {
      label: t("common.cart", "Cart"),
      route: "/cart",
      icon: "shopping_cart",
      showBadge: true,
    },
  ];

  const danger = [
    {
      label: t("portal.deleteAccount", "Delete Account"),
      route: "/account/delete-account",
      icon: "delete_outline",
      tone: "danger",
    },
  ];

  return { account, store, danger };
}

export function portalHubPath() {
  return "/account";
}

export function portalBackPath(pathname) {
  const path = String(pathname || "");
  if (path.includes("/chat")) return path.replace(/\/chat$/, "");
  // Hub first: "/core-returns" must not match the "/core-return" wizard segment.
  if (path === "/account/core-returns" || path === "/account/core-returns/") {
    return "/account";
  }
  if (/\/core-return\/?$/.test(path)) return "/account/core-returns";
  if (path.includes("/warranty")) {
    return path.replace(/\/warranty$/, "");
  }
  if (path.startsWith("/account/orders/")) return "/account/orders";
  if (path.startsWith("/account/distributor-requests/")) return "/account/distributor-requests";
  if (path.startsWith("/account/valve-bodies/")) return "/account/valve-bodies";
  if (path.startsWith("/account/warranty-claims/")) return "/account";
  return portalHubPath();
}

export function usePortalSidebarSections(t, pluginRole) {
  return portalSidebarSections(t, isDistributorRole(pluginRole));
}
